/**
 * 新增 修改公用
 */
import utils from 'utils'
class editGoodsContrastCtrl {
    constructor($scope, httpRequest, $state, $stateParams, formvalidateApi, logger) {
        $scope.goodsInfoForm = {
            custSwitch: 0
        }
        //获取字典类型
        httpRequest.get_dictByTypeArr(['is_privilege']).then((res) => {
            if (res.data.value) {
                $scope.is_privilege = res.data.value.is_privilege
                init()
            }
        })
        function init () {
            const { id } = $stateParams
            if (id) {
                $scope.isEdit = true
                httpRequest.get_sysGoodsMappingQry(id).then((res) => {
                    $scope.goodsInfoForm = res.data.value
                    $scope.goodsInfoForm.isPrivilegeText = $scope.is_privilege.filter(item => item.enumCode == $scope.goodsInfoForm.isPrivilege)[0].enumName
                    $scope.goodsInfoForm.custSwitch=$scope.goodsInfoForm.custSwitch*1
                })
            }
        }
        const submitHandler = {
            add () {
                utils.loading('正在提交')
                httpRequest.post_sysGoodsMappingAdd($scope.goodsInfoForm,'新增成功！').then(() => {
                    $state.go('outputManage.ovat.goodsContrast.list')
                }).finally(() => {
                    utils.loaded()
                })
            },
            edit () {
                httpRequest.post_sysGoodsMappingEdit($scope.goodsInfoForm, '修改成功！').then(() => {
                    $state.go('outputManage.ovat.goodsContrast.list')
                })
            },
        }
        // 修改 新增 新增并继续
        $scope.submit = function (method) {
            const mark = formvalidateApi.run()
            if (!mark) {
                return
            }
            if(!checkInfo())return
            submitHandler[method]()
        }
        
        $scope.cancel = function () {
            $state.go('outputManage.ovat.goodsContrast.list')
        }
        function checkInfo() {
            let {unitConverRate,custSwitch,custConfig,goodsName,taxMergeName,taxShortName,taxMergeCode,goodsId}=$scope.goodsInfoForm
            if(unitConverRate){
                if(unitConverRate>0){}else{
                    logger.logError('单位换算率必须大于0')
                    return false
                }
            }
            if(custSwitch==1&&!custConfig){
                logger.logError('指定生效时请填写指定购方名称')
                return false
            }
            if(!goodsName){
                logger.logError('请填写开票商品名称')
                return false 
            }
            if(!goodsId){
                logger.logError('请选择商品管理已维护商品')
                return false  
            }
            if(!taxMergeName||!taxShortName||!taxMergeCode){
                logger.logError('请重新选择开票商品缺少必要参数')
                return false 
            }
            return true
        }
        $scope.validateRules ={
            goodsName: [{
                erromsg: '最多92个字符',
                condition(value) {
                    // 规则
                    return (lengthForString(value.toString()) > 92)
                },
            }],
        }
        function lengthForString(temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i += 1) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    len += 1
                } else {
                    len += 2
                }
            }
            return len
        }
        // 选中商品行
        $scope.qryTaxClassInfo = function qryTaxClassInfo ($item) {
            $scope.goodsInfoForm =Object.assign($scope.goodsInfoForm,$item);
            try {
                $scope.goodsInfoForm.isPrivilegeText = $scope.is_privilege.filter(item => item.enumCode == $scope.goodsInfoForm.isPrivilege)[0].enumName
            } catch (err) {
                $scope.goodsInfoForm.isPrivilegeText = $scope.goodsInfoForm.isPrivilege
            }
        }
    }
}
editGoodsContrastCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams', 'formvalidateApi', 'logger']
export default editGoodsContrastCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/baseData/goodsContrast/editGoodsContrastCtrl.js